"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var min_1 = __importDefault(require("./min"));
var max_1 = __importDefault(require("./max"));
exports.default = (function (data) { return max_1.default(data) - min_1.default(data) / 2; });
//# sourceMappingURL=midRange.js.map